module.exports = __webpack_public_path__ + "static/media/appointArbitrator.5b1cacaa.png";